import {
  Folder, Smartphone, Wifi, Tv, Package, Boxes, Store, Target,
  Monitor, Laptop, Headphones, Router, Signal, Phone, Tablet, Cable,
  ShoppingCart, ShoppingBag, Tag, Zap, Star, Trophy, Gift, Flame,
  Briefcase, Building2, Globe, HardDrive, Server, Cpu, Battery, PlugZap,
  Mic, Camera, Printer, Mouse, Keyboard, Watch, Speaker, Radio
} from "lucide-react";

const ICON_MAP = {
  Folder, Smartphone, Wifi, Tv, Package, Boxes, Store, Target,
  Monitor, Laptop, Headphones, Router, Signal, Phone, Tablet, Cable,
  ShoppingCart, ShoppingBag, Tag, Zap, Star, Trophy, Gift, Flame,
  Briefcase, Building2, Globe, HardDrive, Server, Cpu, Battery, PlugZap,
  Mic, Camera, Printer, Mouse, Keyboard, Watch, Speaker, Radio,
};

export const CATALOG_ICONS = Object.keys(ICON_MAP);

export function CatalogIcon({ name, size = 20, className = "" }) {
  const Comp = ICON_MAP[name] || Folder;
  return <Comp size={size} className={className} />;
}
